// extracted by mini-css-extract-plugin
export default {"container":"notfound_container__15St0","title":"notfound_title__Armup","link":"notfound_link__rS9Nx"};